import { Injectable } from '@angular/core';
import { DataEntryEmailDto } from '@osos/shared/api';
import { EntryEmailsPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { EntryEmailsParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class EntryEmailsFactoryService extends FactoryBase<
  DataEntryEmailDto,
  EntryEmailsPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: EntryEmailsParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: EntryEmailsPresenterModel): DataEntryEmailDto {
    const parser = this.getParser(
      DataEntryEmailDto,
      EntryEmailsPresenterModel,
      1,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: DataEntryEmailDto): EntryEmailsPresenterModel {
    const parser = this.getParser(
      DataEntryEmailDto,
      EntryEmailsPresenterModel,
      1,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
